const getCsrfToken = () => {
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  return metaTag ? metaTag.content : '';
};

export const apiPost = (endpoint, parameters = {}, fetchOptions = {}) => {
  fetchOptions.headers = fetchOptions.headers || {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': getCsrfToken(),
  };

  return fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(parameters),
    ...fetchOptions,
  });
};
